import { Card, Group, Text } from '@mantine/core'
import { LuWind } from 'react-icons/lu'

interface Props {
  /** Lat/Lon of the marina. Default: Benoa Bay, Bali (-8.7486, 115.2067). */
  lat?: number
  lon?: number
  height?: number
}

/**
 * Embed Windy.com weather map for the marina location.
 * Uses free public embed. No API key required.
 */
export function WeatherCard({ lat = -8.7486, lon = 115.2067, height = 360 }: Props) {
  const src = `https://embed.windy.com/embed2.html?lat=${lat}&lon=${lon}&zoom=10&level=surface&overlay=wind&menu=&message=&marker=true&calendar=&pressure=&type=map&location=coordinates&detail=&detailLat=${lat}&detailLon=${lon}&metricWind=default&metricTemp=default&radarRange=-1`
  return (
    <Card padding={0} radius="md" style={{ overflow: 'hidden' }}>
      <Group px="md" py="xs" gap="sm">
        <LuWind size={14} />
        <Text size="xs" fw={600} c="dimmed" tt="uppercase">
          Weather
        </Text>
      </Group>
      <iframe
        src={src}
        title="Windy weather"
        width="100%"
        height={height}
        frameBorder={0}
        style={{ display: 'block', border: 0 }}
      />
    </Card>
  )
}
